import {useState,useEffect} from "react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Table from "../../../../core/dataTable/non-pager/index";
import Modal_Item_Image_Gallery_Edit from "../item/modalItemImageGalleryEdit";
import ImageWithBasePath from "../../../../core/img";
import ImageUploading from 'react-images-uploading';
import {all_routes} from "../../../router/all_routes";
import FormNoData from '../../../formNoData';
// -- biz9 --
import {Data_Logic} from "biz9-data-app";
import {Image_Format,Image_Type,Image_Table,Image_Field,Image_Service,Image_Url,Image_Logic} from "biz9-image";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Image,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field} from "biz9-portal-app";
import {Str,Obj,Log,Status_Type} from "biz9-utility";
import {Message,Type,Url,Field,Title,CMS_Config} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Toast_Message,Template,Storage,System} from "../../../../project";
/* -- biz9 import end -- */
/* - DEFINE -
 * -- ABOUT --
 * post-image-gallery
 * --- BUTTONZ ---
 * btn_image_gallery_back - go back to all image gallerys.
 * btn_post_image_gallery_add - add image gallery.
 * btn_post_image_gallery_delete - delete image gallery.
 * btn_image_gallery_value_edit - update image gallery value.
 * btn_post_copy - copy image gallery.
 * onImage_GalleryImageListDelete - delete image gallery image.
*/
const Item_Image_Gallery_Edit = (props) => {
    const [val_sub_page_title,setValSubPageTitle] = useState(Title.LABEL_CMS_TAB_IMAGE_GALLERY);
    const [val_sub_image_gallery_title,setValSubImage_GalleryTitle] = useState(Str.get_table_by_name(Image_Table.IMAGE_GALLERY,{plural:true}));
    const [formNoDataShow, setFormNoDataShow] = useState(true);
    const [hide_image_gallery_back, setHideImage_GalleryBack] = useState(true);
    const [hide_image_gallerys, setHideImage_GalleryList] = useState(false);
    const [hide_image_gallery_item, setHideImage_GalleryItem] = useState(true);
    const [image_gallery,setImage_Gallery] = useState(Data_Logic.get(Image_Table.IMAGE_GALLERY,0));
    const [value_image_gallery_image,setValueImage_GalleryImage] =  useState("");
    const [hide_btn_image_gallery_image_post,setHideBtnImage_GalleryImagePost] = useState(true);
    const [image_gallery_images,setImage_GalleryImageList] = useState([]);
    const image_image_gallery_image_max_count = 50;
    const [field_values,setFieldValueList] = useState([]);
    const [hide_value_row_edit,setHideValueRowEdit] = useState(false);
    const [hide_value_row_image,setHideValueRowImage] = useState(true);
    const [hide_btn_value_image_post,setHideBtnValueImagePost] = useState(false);
    const [image_values,setImageValueList] = useState([]);
    const image_value_max_count = 1;
    const [image_value_primary,setImageValuePrimary] = useState([]);
    const [val_value_id,setValValueId] = useState(0);
    const handle_submit = (event) => {
        event.preventDefault();
    };
    const columns = [
{
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (text: string, record: any) => (
               <h2 className="table-avatar d-flex align-items-center">
               <Link data-bs-toggle="modal" data-bs-target="#modal_edit_image_gallery" to="#" onClick={(e) => { {btn_image_gallery_edit(record.id)} }} className="avatar">
               <ImageWithBasePath src={Image.get_url(record.image_filename,Image_Format.SQUARE_THUMB)} />
               </Link>
               <Link  data-bs-toggle="modal" data-bs-target="#modal_edit_image_gallery" to="#" onClick={(e) => { {btn_image_gallery_edit(record.id)} }} className="text-dark">
                {Str.get_truncate(record.title,CMS_Config.ITEMS_TITLE_COUNT)}
                   </Link>
               </h2>
               ),
         sorter: true
},
{
    title: "Images",
    dataIndex: "data",
    key: "data",
    render: (text: string, record: any) => (
               <h2 className="table-avatar d-flex align-items-center">
               <Link to="#" onClick={(e) => { {btn_image_gallery_value_edit(record.id)} }} className="text-dark">
               {'Modify'}
               </Link>
               </h2>
               ),
},
{
title: "Action",
   dataIndex: "action",
   render: (res: string, record: any) => (
           <>
           <div className="dropdown dropdown-action">
           <Link to="#" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
           <FeatherIcon icon="more-vertical" />
           </Link>
           <div className="dropdown-menu dropdown-menu-right">
           <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_copy(record.id)} }} >
           <FeatherIcon icon="copy" /> {Title.LABEL_COPY}
           </Link>
           <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_image_gallery_delete(record.id)} }} >
           <FeatherIcon icon="trash" /> {Title.LABEL_DELETE}
           </Link>
           </div>
           </div>
           </>
           ),
},
];
    useEffect(() => {

    },[props]);
   async function btn_image_gallery_edit(id: any) {
        // -- get-image-gallery, get-image-gallery-images, get-images --
        props.toast_loading(Message.LOADING);
        let foreign_image = Data_Logic.get_foreign(Portal_Value_Type.ITEMS,Image_Table.IMAGE,Portal_Field.PARENT_ID,Portal_Field.ID,{title:Image_Type.IMAGES})
        let option = {foreigns:[foreign_image]};
        let [response,data] = await Portal_Remote_Data.get(App.get_url(Portal_Url.DATA_GET),Image_Table.IMAGE_GALLERY,id,option);
        if(data.images){
            setImage_GalleryImageList(data.images);
        }
        setImage_Gallery(data);
        props.toast_dismiss();
    };
    const btn_image_gallery_back = () => {
        setHideImage_GalleryList(false);
        setHideImage_GalleryItem(true);
        setHideImage_GalleryBack(true);
    };
    const update_image_gallerys = (image_gallerys) => {
        props.onUpdate(image_gallerys);
    };
    //9_image_gallery_post 9_image_gallery
    async function btn_post_image_gallery_add() {
        // -- post-new-image-gallery --
        setImage_Gallery(Data_Logic.get(Image_Table.IMAGE_GALLERY,0));
    }
    //9_image_gallery_delete
    async function btn_post_image_gallery_delete(id: any) {
        // -- delete-image-gallery --
        if(window.confirm(Message.CONFIRM)){
            props.toast_loading(Message.DELETING);
            let [response,data] = await Portal_Remote_Data.delete(App.get_url(Portal_Url.DATA_DELETE),Image_Table.IMAGE_GALLERY,id);
                props.onUpdate(props.image_gallerys.filter(item=>item.id!==id));
                props.toast_success(response.message);
        }
    };
    //---9_image_gallery_edit   //9_post_gallery 9_gallery_edit
    async function btn_image_gallery_value_edit(id) {
        // -- get-post-image-gallery-images --
        props.toast_loading(Message.LOADING);
        let foreign_image = Data_Logic.get_foreign(Portal_Value_Type.ITEMS,Image_Table.IMAGE,Portal_Field.PARENT_ID,Portal_Field.ID,{title:Image_Type.IMAGES,sort_by:{date_create:1}})
        let option = {foreigns:[foreign_image]};
        let [response,data] = await Portal_Remote_Data.get(App.get_url(Portal_Url.DATA_GET),Image_Table.IMAGE_GALLERY,id,option);
        Log.w('11_response',response);
        Log.w('11_data',data);
        setFieldValueList([]);
        setImage_GalleryImageList([]);
        if(data.images){
            setImage_GalleryImageList(data.images);
        }
        setImage_Gallery(Data_Logic.clean(data));
        setValSubImage_GalleryTitle(data.title);
        setHideImage_GalleryItem(false);
        setHideBtnImage_GalleryImagePost(false);
        props.toast_dismiss();
        setFieldValueList(Data.bind_field_values(data));
        setHideImage_GalleryList(true);
        setHideImage_GalleryBack(false);
   };
   async function btn_post_copy(id: any) {
       // -- post-copy-image-gallery --
        props.toast_loading(Message.SAVING);
        let [response,data] = await Portal_Remote_Data.copy(App.get_url(Portal_Url.DATA_COPY),Image_Table.IMAGE_GALLERY,id);
        props.onUpdate(([data, ...props.image_gallerys]));
        props.toast_success(response.message);
   };
   //---image_gallery image list start -- 9_image_gallery_photo_edit
   async function update_image_gallery_image_field(id,field,value){
       // -- post-image-gallery-image-field --
        props.toast_loading(Message.LOADING);
        let image = Data_Logic.get(Image_Table.IMAGE,id);
        image[field] = value;
        let option = {overwrite:false,clean:true};
        let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Image_Table.IMAGE,image,option);
        if(response.status == Status_Type.FAIL){
            props.toast_error(response.message);
        }else{
            props.toast_success(response.message);
        }
    };
    const updateValueImage_GalleryImage = (id,field,event) => {
        setValueImage_GalleryImage(event.target.value);
        const update_image_gallery_images = image_gallery_images.map((item) => {
                if (item.id === id) {
                    return { ...item, [field]: event.target.value };
                }
            return item;
        });
        setImage_GalleryImageList(update_image_gallery_images);
    };
    //9_image_galley_image_post
   async function onImage_GalleryImageListChange(image_upload, addUpdateIndex){
        // -- post-image-gallery-image, post-images --
        props.toast_loading(Message.SAVING);
        //let parent = Data_Logic.get(Portal_Table.IMAGE_GALLERY,props.parent_id,{data:{parent_table:props.parent_table,parent_id:props.parent_id}});
        setHideBtnImage_GalleryImagePost(true);
        let images = [];
        for(let a = 0; a< image_upload.length; a++){
            if(Str.check_is_null(image_upload[a].image_filename)){
                let image = Data_Logic.get(Image_Table.IMAGE,0,{parent:image_gallery,data:{base64:image_upload[a][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[a][Image_Field.FILE][Image_Field.NAME])}});
                images.push(image);
            }
        }
        // -- service --
        let option = {};
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),images,option);
        if(response.status == Status_Type.SUCCESS){
            setHideBtnImage_GalleryImagePost(false);
            setImage_GalleryImageList([...data,...image_gallery_images]);
            props.toast_success(response.message);
        }else{
            setHideBtnImage_GalleryImagePost(false);
            props.toast_error(response.message);
        }
    };
    async function onImage_GalleryImageListDelete(id) {
        // -- delete-image-gallery --
        if (window.confirm(Message.CONFIRM)) {
            props.toast_loading(Message.DELETING);
            let image = image_gallery_images.find(item => item.id === id);
            if(!Obj.check_is_empty(image)&&!Str.check_is_null(image.id)){
                let [response,data] = await Portal_Remote_Data.delete(App.get_url(Portal_Url.DATA_DELETE),Image_Table.IMAGE,image.id);
                    setImage_GalleryImageList(image_gallery_images.filter(item => item.id !== id));
                    if(response.status == Status_Type.FAIL){
                        props.toast_error(response.message);
                    }else{
                        props.toast_success(response.message);
                    }
            }
        }
    };
    const btn_add_row = () => {
        // -- post-field-value, post-field-values, post-image-gallery-field-value
        let title = 'new_item';
        image_gallery['field_'+String(Number(field_values.length+1))] = title;
        setFieldValueList([...field_values, {id:Str.get_id(), row_id: field_values.length+1, title:title, value: "" },]);
        setFormNoDataShow(false);
    };
    const btn_remove_row = (id) => {
        // -- delete-field-value, delete-field
        if (window.confirm(Message.CONFIRM)) {
            const item_match = field_values.find(item_find => item_find.id === id);
            delete image_gallery['field_'+item_match.row_id];
            delete image_gallery[Str.get_title_url(item_match.title)];
            let new_field_values = field_values.filter((row) => row.id !== id)
            post_item(new_field_values);
        }
    };
    async function post_item(new_field_values){
        // -- post-image-gallery-field --
        props.toast_loading(Message.SAVING);
        let full_prop_str = "";
        for(const prop in image_gallery){
            full_prop_str = String(prop + " "+full_prop_str);
        }
        for(let b = 1; b < 30; b++){
            const exists = Str.check_if_str_exist(full_prop_str,"field_"+b);
            let title = Str.get_title_url(image_gallery["field_"+b]);
            if(exists){
                delete image_gallery["field_"+b];
                delete image_gallery[title];
            }
        }
        for(let a=0;a<new_field_values.length;a++){
            new_field_values[a].row_id = a+1;
            image_gallery['field_'+(a+1)] = new_field_values[a].title;
            image_gallery[Str.get_title_url(new_field_values[a].title)] = new_field_values[a].value;
        }
        let option = {overwrite:true,clean:true};
        let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Image_Table.IMAGE_GALLERY,image_gallery,option);
        setImage_Gallery(data);
        setFieldValueList(new_field_values);
        props.toast_success(response.message);
    };
    const update_field = (type,id,value,post_data) => {
        // -post-field-value, post-field-image-gallery
        const item_match = field_values.find(item_find => item_find.id === id);
        let new_field_values = [];
        if(type == Portal_Field.TITLE){
            new_field_values = field_values.map((row) => (row.id === id ? { ...row, title:value } : row))
            setFieldValueList(new_field_values);
        }else if(type == Field.VALUE){
            new_field_values = field_values.map((row) => (row.id === id ? { ...row, value: value } : row));
            setFieldValueList(new_field_values);
        }else if(type == Image_Field.IMAGE_FILENAME){
            new_field_values = field_values.map((row) => (row.id === id ? { ...row, value: value, image_filename:value } : row));
            setFieldValueList(new_field_values);
        }
        if(post_data){
            post_item(new_field_values);
        }
    };
    const onImagePrimaryDelete = () => {
        // -- delete-image-gallery --
        if (window.confirm(Message.CONFIRM)) {
            props.toast_loading(Message.DELETING);
            setImageValuePrimary([]);
            setHideBtnValueImagePost(false);
            props.toast_success(Message.DELETED);
        }
    };
    async function onImageRowChange(image_upload, addUpdateIndex){
        // -- post-image-gallery-image --
        props.toast_loading(Message.SAVING);
        setHideBtnValueImagePost(true);
        setHideValueRowImage(true);
        setHideValueRowEdit(true);
        let image = Data_Logic.get(Image_Table.IMAGE,0,{data:{base64:image_upload[0][Image_Field.BASE64]}});
	    let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image]);
        if(data){
            setHideBtnValueImagePost(false);
            setHideValueRowEdit(false);
            update_field(Image_Field.IMAGE_FILENAME,val_value_id,data[0].image_filename,true);
            props.toast_success(response.message);
        }else{
            props.toast_error(response.message);
        }
    };
    const onImageRowDelete = () => {
        // delete-image-row, delete-image-gallery-image
        if (window.confirm(Message.CONFIRM)) {
            props.toast_loading(Message.DELETING);
            setImageValuePrimary([]);
            setHideBtnValueImagePost(false);
            props.toast_success(Message.DELETED);
        }
    };
    async function btn_back_image_value_row(){
        // -- bind-back-image-gallery-home --
        setHideValueRowImage(true);
        setHideValueRowEdit(false);
    };
    async function btn_image_value_row(id){
        // -- bind-image-value-row
        setValValueId(id);
        setHideValueRowImage(false);
        setHideValueRowEdit(true);
    };
     // --- image_gallery image value end -- //
return (<>
 <div className="settings-page-lists">
            <div className="settings-card">
            <div className="settings-card-head bg-light">
            <h4>{val_sub_page_title}</h4>
            </div>
                          <ul className="nav nav-tabs nav-tabs-bottom mb-4" hidden={hide_image_gallery_back}>
                    <li className="nav-item">
                        <Link to={'#'} hidden={hide_image_gallery_back} className="nav-link" onClick={() => btn_image_gallery_back()} >
                            {"<-- " + Title.LABEL_GO_BACK}
                        </Link>
                    </li>
                </ul>
                {/* -- TABLE START -- */}
                <div className="content" hidden={hide_image_gallerys}>
                    <div className="d-flex " >
                        <Link   onClick={() => btn_post_image_gallery_add()} to="#" data-bs-toggle="modal" data-bs-target="#modal_edit_image_gallery" className="btn btn-primary" style={{margin:10}}>
                            {Title.LABEL_ADD}
                        </Link>
                    </div>
                    <div className="table-responsive custom-table" >
                        <Table allow_multiple={false} table={Image_Table.IMAGE_GALLERY} dataSource={props.image_gallerys} columns={columns} Selection={false} />
                    </div>
                    <div className="table-footer">
                        <div id="tablepage" />
                    </div>
                </div>
                {/* -- TABLE END -- */}

                {/* -- EDIT START -- */}
                <div className="content" hidden={hide_image_gallery_item}>
                    <div className="settings-card">
                                    <div className="settings-card-head bg-light">
                                        <h6>{val_sub_image_gallery_title}</h6>
                                    </div>
                        </div>

                    {/* -- TAB-NAV START -- */}
                        <div className="settings-page-lists">

                            <ul className="settings-head nav nav-tabs" role="tablist" style={{ paddingLeft: '10px' }}>

                                <li className="nav-item pl-10" role="presentation">
                                    <Link to="#" className="nav-link active" data-bs-toggle="tab" data-bs-target="#tab_image_gallery_image" aria-selected="false" role="tab" tabIndex={-1}>
                                        {Title.LABEL_CMS_TAB_IMAGE}
                                    </Link>
                                </li>

                                <li className="nav-item" role="presentation">
                                    <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_image_gallery_value" aria-selected="false" role="tab" tabIndex={-1}>
                                        {Title.LABEL_CMS_TAB_VALUE}
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    {/* -- TAB-NAV END -- */}
                     {/* -- TAB-CONTENT - START -- */}
                        <div className="tab-content">
                            {/* Image Tab - Start */}
                            <div className="tab-pane fade show active" id="tab_image_gallery_image" role="tabpanel">
                                <div className="settings-card">
                                    <div className="settings-card-head bg-light">
                                        <h6>{Str.get_table_by_name(Image_Table.IMAGE,{plural:true})}</h6>
                                    </div>
                                    <form onSubmit={handle_submit}>
                                        <div className="settings-card-body">
                                           <div className="row">
            <ImageUploading multiple={true} value={image_gallery_images} onChange={onImage_GalleryImageListChange} maxNumber={image_image_gallery_image_max_count} dataURLKey={Image_Field.BASE64}>
            {({imageList,onImageUpload,onImageRemoveAll,onImageUpdate,isDragging,dragProps}) => (
                    <div className="upload__image-wrapper">
                    <button hidden={hide_btn_image_gallery_image_post} className="btn btn-secondary mb-3" style={isDragging ? { color: 'red' } : undefined} onClick={onImageUpload} {...dragProps}>
                    {Title.LABEL_UPLOAD}
                    </button>
                    {image_gallery_images.map((image, index) => (
                                <div className="flex-container" key={image.id}>
                                <div className="flex-item">
                                {index+1+". "}
                                <img alt={""} src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} />
                                </div>
                                <div className="flex-item">
                                    <div className="form-wrap mb-1">
                                        <input onBlur={() => update_image_gallery_image_field(image.id,Portal_Field.TITLE,value_image_gallery_image)} onChange={(e) => updateValueImage_GalleryImage(image.id,Portal_Field.TITLE,e)} value={image.title? image.title : ""} type="text" className="form-control" placeholder="Title" />
                                    </div>
                                    <div className="form-wrap">
                                        <textarea onBlur={() => update_image_gallery_image_field(image.id,Field.DESCRIPTION,value_image_gallery_image)} onChange={(e) => updateValueImage_GalleryImage(image.id,Field.DESCRIPTION,e)} value={image.description ? image.description : ""} className="form-control text-area" placeholder="Value" />
                                    </div>
                                <div className="parent-container">
                                <div className="bottom-right-absolute">
                                <Link onClick={() => onImage_GalleryImageListDelete(image.id) } to="#" className="m-4" >
                                <FeatherIcon icon="trash-2" />
                                </Link>
                                </div>
                                </div>
                                </div>
                                </div>
                        ))}
            </div>
                )}
    </ImageUploading>

        </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {/* /Image Tab - End  */}



                            {/* Value Tab - Start */}
                            <div className="tab-pane fade show" id="tab_image_gallery_value" role="tabpanel">
                                <div className="settings-card">
                                    <div className="settings-card-head bg-light">
                                        <h6>{Title.LABEL_CMS_TAB_IMAGE_GALLERY}{'cool'}</h6>
                                    </div>
                                    <form onSubmit={handle_submit}>
                                        <div className="settings-card-body">
                                           <div className="row">
                                           {/* ROW-START */}
            <div className='biz_row_start' style={{ display: hide_value_row_edit ? 'none' : 'block' }} >

            {field_values.length<=0 && <FormNoData/>}
            {field_values.map((row) => (
                        <div className="row">
                        <div className="col-md-12">
                        <div className="form-wrap">
                        <label className="col-form-label">
                        Title
                        </label>
                        <div className="form-wrap mb-1">
                        <input value={!Str.check_is_null(row.title)?row.title:''} onChange={(e) => update_field(Portal_Field.TITLE,row.id,e.target.value,false)} type="text" className="form-control" placeholder="Title" onBlur={(e) => update_field(Portal_Field.TITLE,row.id,e.target.value,true)} />
                        </div>
                        </div>
                        <div className="form-wrap">
                        <label className="col-form-label">
                        Value
                        </label>
                        <div className="form-wrap">
                        <textarea hidden={row.image_filename} value={!Str.check_is_null(row.value)?row.value:''} onChange={(e) => update_field(Field.VALUE,row.id,e.target.value,false)} onBlur={(e) => update_field(Field.VALUE,row.id,e.target.value,true)} className="form-control text-area" placeholder="Value"  />
                        </div>
                        </div>
                        </div>
                        <div style={{ textAlign: 'left' }}>
                        <Link onClick={(e)=>{{e.preventDefault(); btn_image_value_row(row.id)}}} to={"#"} className="mb-4" style={{ paddingRight:'10px' }} >
                        <FeatherIcon icon="camera" />
                        <img style={{ padding:"10px"}} hidden={!row.image_filename}  src={Image.get_url(row.image_filename,Image_Format.SQUARE_THUMB)} alt=""   />
                        </Link>
                        <Link  onClick={(e)=>{{e.preventDefault(); btn_remove_row(row.id)}}}to="#" className="mb-4" >
                        <FeatherIcon icon="trash-2" />
                        </Link>
                        </div>
                        <hr/>
                        </div>
                        ))}

            <div className="review-btn text-center">
                <Link onClick={(e)=>{{ e.preventDefault();btn_add_row()}}} to={"#"} className="btn btn-dark text-white">
                {" "}
            <i className="ti ti-loader-3 me-1 rotate" /> Add{" "}
            </Link>
                </div>
                </div>
                {/* ROW-END */}

            {/* ROW-START */}
            <div className='biz_row_start'>
                <div className="col-md-12" hidden={hide_value_row_image}>
                <Link onClick={(e)=>{{e.preventDefault();btn_back_image_value_row()}}} to={'#'} className="nav-link" >
                {"<- Back"}
            </Link>
                <div className="form-wrap mb-3 mt-5">
                <ImageUploading
                value={image_value_primary}
            onChange={onImageRowChange}
            maxNumber={image_value_max_count}
            dataURLKey={Image_Field.BASE64}>
            {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    isDragging,
                    dragProps,
                    }) => (
                        <div className="upload__image-wrapper">
                        <button hidden={hide_btn_value_image_post} className="btn btn-secondary mb-2"
                        style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
                        {...dragProps} >
                        Image
                        </button>
                        &nbsp;
                        {imageList.map((image, index) => (
                                    <div key={index} className="image-item">
                                    <img  src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                                    <div className="image-item__btn-wrapper">
                                    <Link onClick={() => onImageRowDelete() } to="#" className="mb-2" >
                                    <FeatherIcon icon="trash-2" />

                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                        </div>
                        )}
            </ImageUploading>
                </div>
                </div>

                </div>
                {/* ROW-END */}
 </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {/* /Value Tab - End  */}

                        </div>
                        {/* -- TAB-CONTENT - END -- */}
                </div>
                {/* -- EDIT END -- */}
            </div>
            </div>
            <Modal_Item_Image_Gallery_Edit toast_loading={props.toast_loading} toast_success={props.toast_success} toast_error={props.toast_error} toast_dismiss={props.toast_dismiss} image_gallerys={props.image_gallerys} onUpdate={update_image_gallerys} image_gallery={image_gallery} parent_table={props.parent_table} parent_id={props.parent_id}/>
           </>);
};
export default Item_Image_Gallery_Edit;
